import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { ASSET_BASE_URL } from "../../config/env";
import "./index.css";

/* ─────────────────────────────────────────────────────────────
   Content — edit here, the layout below reads from these lists.
   ───────────────────────────────────────────────────────────── */

const CONTACT = {
  email: "vrplay.sdtech@gmail.com",
  phoneDisplay: "+91 91252 53535",
  phoneE164: "919125253535", // used for tel: and WhatsApp links
  hours: "Mon–Sat, 10 AM – 5 PM IST",
  address:
    "Pedda Avutapalli, Unguturu Mandal, Krishna District, Vijayawada, Andhra Pradesh 521286",
};

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=in.vrplay.tv";
const SCHOOL_ERP_URL = "https://childinfo.in";
const PRIVACY_URL = "https://vrplay.in/privacy-policy.html";
const TERMS_URL = "https://vrplay.in/terms-and-conditions.html";

// Add your real profile URLs; links without a URL are not shown.
const SOCIAL = [
  { name: "Facebook", url: "" },
  { name: "Instagram", url: "" },
  { name: "YouTube", url: "" },
  { name: "LinkedIn", url: "" },
  { name: "X", url: "" },
];

const FEATURES = [
  {
    icon: "tv",
    title: "Live TV channels",
    desc: "200+ channels across news, movies, music, devotional and kids, in HD — on the big screen at home.",
  },
  {
    icon: "apps",
    title: "OTT apps included",
    desc: "Watcho, ETV Win, Pioneer IPTV and more come with your plan. One subscription, one login.",
  },
  {
    icon: "devices",
    title: "TV and phone",
    desc: "Watch on Android TV at home and on your Android phone when you're out. Each plan covers a set number of devices.",
  },
  {
    icon: "operator",
    title: "Recharge through your operator",
    desc: "Your local cable operator activates and renews your plan — pay the way you already do, no card needed.",
  },
];

const PLANS = [
  {
    name: "Basic",
    price: "₹199",
    period: "per month",
    features: ["200+ live TV channels", "HD quality"],
    popular: false,
  },
  {
    name: "Premium",
    price: "₹399",
    period: "per month",
    features: ["250+ live TV channels", "Full HD", "OTT apps included"],
    popular: true,
  },
  {
    name: "Family",
    price: "₹699",
    period: "per month",
    features: ["300+ live TV channels", "4K HDR quality", "Most OTT apps", "Kids profile"],
    popular: false,
  },
];

const OPERATOR_PERKS = [
  ["Customers in one list", "Every subscriber with their plans, expiry dates and phone numbers."],
  ["Renewals you won't miss", "See who expires today, tomorrow and this week, and renew in one click."],
  ["Wallet-based recharges", "Top up once, recharge any customer instantly, with a full history."],
  ["Broadband too", "Manage Pioneer, DVPL and RailTel internet customers alongside TV."],
];

const EDUCATION_FEATURES = [
  "Admissions",
  "Attendance",
  "Fee collection and reports",
  "Exams and results",
  "Parent and teacher portal",
  "Transport",
  "Library",
  "SMS and WhatsApp alerts",
];

const FAQS = [
  {
    q: "What is VRPLAY?",
    a: "VRPLAY is a live TV and OTT streaming service from SD Technologies. You get TV channels and apps like Watcho and ETV Win in one subscription, activated through your local cable operator.",
  },
  {
    q: "Which devices can I watch on?",
    a: "Android TV and Android phones today. Amazon Fire TV, LG webOS and Samsung TV apps are coming soon.",
  },
  {
    q: "How do I subscribe or renew?",
    a: "Contact your local cable operator — they activate and renew VRPLAY plans for you. If you don't have a VRPLAY operator nearby, send us a message and we'll connect you with one.",
  },
  {
    q: "I'm a cable operator. How do I partner with VRPLAY?",
    a: "Send us a message with 'Partnership' as the subject. We'll set up your operator account, plans and pricing, and train you on the dashboard.",
  },
  {
    q: "Is my account secure?",
    a: "Your account is protected by password login and encrypted connections, and each plan limits how many devices can be signed in at once.",
  },
];

// Hero background. Ideally host your own photo (e.g. a family watching TV)
// at ASSET_BASE_URL and point this at it, so the page doesn't depend on
// an outside image site.
const HERO_IMAGE = "https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?w=1800&q=80";

/* ───────────────────────── Small pieces ───────────────────────── */

const Icon = ({ name }) => {
  const common = { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true };
  switch (name) {
    case "tv":
      return <svg {...common}><rect x="3" y="5" width="18" height="12" rx="2" /><path d="M8 21h8M12 17v4M9 2l3 3 3-3" /></svg>;
    case "apps":
      return <svg {...common}><rect x="4" y="4" width="7" height="7" rx="1.5" /><rect x="13" y="4" width="7" height="7" rx="1.5" /><rect x="4" y="13" width="7" height="7" rx="1.5" /><rect x="13" y="13" width="7" height="7" rx="1.5" /></svg>;
    case "devices":
      return <svg {...common}><rect x="2" y="4" width="14" height="10" rx="1.5" /><path d="M6 18h6" /><rect x="17" y="8" width="5" height="12" rx="1.2" /></svg>;
    case "operator":
      return <svg {...common}><path d="M3 21h18M5 21V9l7-5 7 5v12" /><path d="M10 21v-6h4v6" /></svg>;
    case "check":
      return <svg {...common} width="18" height="18"><path d="M5 12.5l4.5 4.5L19 7" /></svg>;
    case "mail":
      return <svg {...common}><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3.5 6.5l8.5 6 8.5-6" /></svg>;
    case "phone":
      return <svg {...common}><path d="M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z" /></svg>;
    case "pin":
      return <svg {...common}><path d="M12 21s-7-6.2-7-11.5a7 7 0 0114 0C19 14.8 12 21 12 21z" /><circle cx="12" cy="9.5" r="2.5" /></svg>;
    case "plus":
      return <svg {...common} width="20" height="20"><path d="M12 5v14M5 12h14" /></svg>;
    default:
      return null;
  }
};

const PlayStoreBadge = ({ className = "" }) => (
  <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className={`vrh-store ${className}`}>
    <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
      <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.199l2.807 1.626a1 1 0 010 1.732l-2.807 1.626L15.206 12l2.492-2.492zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z" />
    </svg>
    <span>
      <small>Get it on</small>
      Google Play
    </span>
  </a>
);

/** The red cable from the VRPLAY logo, ending in coloured wires. Decorative. */
const CableLine = () => (
  <svg className="vrh-cable" viewBox="0 0 1200 48" preserveAspectRatio="none" aria-hidden="true">
    <path d="M0 24 H1108" stroke="var(--red)" strokeWidth="18" strokeLinecap="round" fill="none" />
    <path d="M1106 18 C1140 14 1170 10 1198 6" stroke="#1f2a44" strokeWidth="3" fill="none" />
    <path d="M1106 22 C1145 21 1175 20 1198 19" stroke="var(--green-500)" strokeWidth="3" fill="none" />
    <path d="M1106 26 C1145 28 1175 30 1198 32" stroke="#555" strokeWidth="3" fill="none" />
    <path d="M1106 30 C1140 35 1168 40 1190 44" stroke="#1a9a3a" strokeWidth="3" fill="none" />
  </svg>
);

/** Small mock of the real operator portal (Expiry Overview). */
const OperatorPreview = () => (
  <div className="vrh-portal" aria-hidden="true">
    <div className="vrh-portal__top">
      <span className="vrh-portal__dots"><i /><i /><i /></span>
      <span>Operator dashboard</span>
    </div>
    <div className="vrh-portal__body">
      <p className="vrh-portal__heading">Renewals this week</p>
      {[
        ["VRPlay", [6, 2, 9, 4, 21]],
        ["Watcho", [3, 1, 4, 2, 11]],
        ["Pioneer IPTV", [2, 0, 3, 5, 14]],
      ].map(([name, n]) => (
        <div className="vrh-portal__row" key={name}>
          <span className="vrh-portal__name">{name}</span>
          <span className="vrh-portal__cells">
            <span className="past">{n[0]}<small>Last 7d</small></span>
            <span className="past">{n[1]}<small>Yesterday</small></span>
            <span className="today">{n[2]}<small>Today</small></span>
            <span className="soon">{n[3]}<small>Tomorrow</small></span>
            <span className="soon">{n[4]}<small>Next 7d</small></span>
          </span>
        </div>
      ))}
      <div className="vrh-portal__foot">
        <span>Wallet balance</span>
        <b>₹12,450</b>
      </div>
    </div>
  </div>
);

/* ───────────────────────────── Page ───────────────────────────── */

const Home = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState(0);
  const [scrolled, setScrolled] = useState(false);

  const [form, setForm] = useState({ name: "", phone: "", email: "", subject: "General enquiry", message: "" });
  const [formError, setFormError] = useState("");
  const [sent, setSent] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close the mobile menu with Escape
  useEffect(() => {
    if (!menuOpen) return undefined;
    const onKey = (e) => e.key === "Escape" && setMenuOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [menuOpen]);

  const pickSubject = (subject) => setForm((f) => ({ ...f, subject }));

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    if (formError) setFormError("");
  };

  // The old form only pretended to send (a setTimeout). This opens a
  // real WhatsApp chat (or email) with the message already written.
  const buildMessage = () => {
    const details = [
      `Subject: ${form.subject}`,
      `Name: ${form.name.trim()}`,
      form.phone.trim() && `Phone: ${form.phone.trim()}`,
      form.email.trim() && `Email: ${form.email.trim()}`,
    ].filter(Boolean);
    return `${details.join("\n")}\n\n${form.message.trim()}`;
  };

  const validate = () => {
    if (!form.name.trim() || !form.message.trim()) {
      setFormError("Add your name and a message so we know how to help.");
      return false;
    }
    if (!form.phone.trim() && !form.email.trim()) {
      setFormError("Add a phone number or email so we can reply.");
      return false;
    }
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      setFormError("That email address doesn't look complete — check it and try again.");
      return false;
    }
    return true;
  };

  const sendWhatsApp = (e) => {
    e.preventDefault();
    if (!validate()) return;
    window.open(`https://wa.me/${CONTACT.phoneE164}?text=${encodeURIComponent(buildMessage())}`, "_blank", "noopener");
    setSent(true);
  };

  const sendEmail = () => {
    if (!validate()) return;
    window.location.href = `mailto:${CONTACT.email}?subject=${encodeURIComponent(`[VRPLAY] ${form.subject}`)}&body=${encodeURIComponent(buildMessage())}`;
    setSent(true);
  };

  const navLinks = [
    ["#watch", "What you get"],
    ["#plans", "Plans"],
    ["#operators", "For operators"],
    ["#school-erp", "School ERP"],
    ["#help", "Help"],
  ];

  return (
    <div className="vrh">
      <a href="#main" className="vrh-skip">Skip to content</a>

      {/* ── Navigation ── */}
      <header className={`vrh-nav ${scrolled ? "is-scrolled" : ""} ${menuOpen ? "is-open" : ""}`}>
        <div className="vrh-wrap vrh-nav__inner">
          <a href="#top" className="vrh-nav__logo" aria-label="VRPLAY home">
            <img src={`${ASSET_BASE_URL}/vrplay1.png`} alt="VRPLAY" />
          </a>

          <nav className="vrh-nav__links" aria-label="Main">
            {navLinks.map(([href, label]) => (
              <a key={href} href={href}>{label}</a>
            ))}
          </nav>

          <div className="vrh-nav__actions">
            <a href="#contact" className="vrh-nav__contact">Contact</a>
            <Link to="/login" className="vrh-btn vrh-btn--primary vrh-btn--sm">Log in</Link>
          </div>

          <button
            type="button"
            className="vrh-nav__toggle"
            aria-expanded={menuOpen}
            aria-controls="vrh-mobile-menu"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            onClick={() => setMenuOpen((o) => !o)}
          >
            <span /><span /><span />
          </button>
        </div>

        <div id="vrh-mobile-menu" className="vrh-nav__mobile" hidden={!menuOpen}>
          {navLinks.map(([href, label]) => (
            <a key={href} href={href} onClick={() => setMenuOpen(false)}>{label}</a>
          ))}
          <a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a>
        </div>
      </header>

      <main id="main">
        {/* ── Hero ── */}
        <section className="vrh-hero" id="top">
          <div className="vrh-wrap">
            <div className="vrh-hero__card" style={{ "--hero-img": `url(${HERO_IMAGE})` }}>
              <div className="vrh-hero__copy">
                <p className="vrh-hero__kicker">Live TV + OTT, from SD Technologies</p>
                <h1>Every channel and app your family watches, in one subscription.</h1>
                <p className="vrh-hero__lead">
                  Live TV channels plus Watcho, ETV Win and more — on your Android TV and phone,
                  activated and renewed by your local cable operator.
                </p>
                <div className="vrh-hero__cta">
                  <PlayStoreBadge />
                  <a href="#plans" className="vrh-btn vrh-btn--ghost">See plans</a>
                </div>
              </div>
              <dl className="vrh-hero__facts">
                <div><dt>200+</dt><dd>live channels</dd></div>
                <div><dt>10,000+</dt><dd>viewers</dd></div>
                <div><dt>2 screens</dt><dd>TV and phone</dd></div>
              </dl>
            </div>
            <CableLine />
          </div>
        </section>

        {/* ── Devices strip ── */}
        <section className="vrh-devices" aria-label="Supported devices">
          <div className="vrh-wrap vrh-devices__inner">
            <p>Watch on</p>
            <ul>
              <li className="is-on">Android TV</li>
              <li className="is-on">Android phones</li>
              <li>Amazon Fire TV <em>soon</em></li>
              <li>LG webOS <em>soon</em></li>
              <li>Samsung TV <em>soon</em></li>
            </ul>
          </div>
        </section>

        {/* ── What you get ── */}
        <section className="vrh-section" id="watch">
          <div className="vrh-wrap">
            <div className="vrh-head">
              <h2>What you get with VRPLAY</h2>
              <p>Everything a household watches, on the screens it already owns.</p>
            </div>
            <div className="vrh-features">
              {FEATURES.map((f) => (
                <article key={f.title} className="vrh-feature">
                  <span className="vrh-feature__icon"><Icon name={f.icon} /></span>
                  <h3>{f.title}</h3>
                  <p>{f.desc}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ── Plans ── */}
        <section className="vrh-section vrh-section--tint" id="plans">
          <div className="vrh-wrap">
            <div className="vrh-head">
              <h2>Plans</h2>
              <p>Monthly prices. Your cable operator activates the plan and handles renewals.</p>
            </div>
            <div className="vrh-plans">
              {PLANS.map((plan) => (
                <article key={plan.name} className={`vrh-plan ${plan.popular ? "is-popular" : ""}`}>
                  {plan.popular && <p className="vrh-plan__tag">Most chosen</p>}
                  <h3>{plan.name}</h3>
                  <p className="vrh-plan__price">
                    <b>{plan.price}</b> <span>{plan.period}</span>
                  </p>
                  <ul>
                    {plan.features.map((f) => (
                      <li key={f}><Icon name="check" />{f}</li>
                    ))}
                  </ul>
                  <a
                    href="#contact"
                    className={`vrh-btn ${plan.popular ? "vrh-btn--primary" : "vrh-btn--outline"}`}
                    onClick={() => pickSubject(`${plan.name} plan`)}
                  >
                    Get {plan.name}
                  </a>
                </article>
              ))}
            </div>
            <p className="vrh-plans__note">
              Already a customer? Ask your operator to renew, or <Link to="/login">log in</Link> if you're an operator.
            </p>
          </div>
        </section>

        {/* ── Operators ── */}
        <section className="vrh-section vrh-section--dark" id="operators">
          <div className="vrh-wrap vrh-split">
            <div className="vrh-split__copy">
              <h2>For cable operators</h2>
              <p className="vrh-lead">
                Offer your customers live TV and OTT apps under your own network, and run
                everything — subscribers, renewals and payments — from one dashboard.
              </p>
              <dl className="vrh-perks">
                {OPERATOR_PERKS.map(([t, d]) => (
                  <div key={t}>
                    <dt>{t}</dt>
                    <dd>{d}</dd>
                  </div>
                ))}
              </dl>
              <div className="vrh-actions">
                <a href="#contact" className="vrh-btn vrh-btn--light" onClick={() => pickSubject("Operator partnership")}>
                  Become a partner
                </a>
                <Link to="/login" className="vrh-btn vrh-btn--ghost">Operator login</Link>
              </div>
            </div>
            <OperatorPreview />
          </div>
        </section>

        {/* ── School ERP ── */}
        <section className="vrh-section" id="school-erp">
          <div className="vrh-wrap vrh-erp">
            <div className="vrh-erp__copy">
              <p className="vrh-erp__from">Also from SD Technologies</p>
              <h2>School management software</h2>
              <p className="vrh-lead">
                Run admissions, attendance, fees, exams and parent communication for your school
                or college from a single dashboard.
              </p>
              <div className="vrh-actions">
                <a href="#contact" className="vrh-btn vrh-btn--primary" onClick={() => pickSubject("School ERP demo")}>
                  Request a demo
                </a>
                <a href={SCHOOL_ERP_URL} target="_blank" rel="noopener noreferrer" className="vrh-btn vrh-btn--outline">
                  Visit childinfo.in
                </a>
              </div>
            </div>
            <ul className="vrh-erp__list">
              {EDUCATION_FEATURES.map((f) => (
                <li key={f}><Icon name="check" />{f}</li>
              ))}
            </ul>
          </div>
        </section>

        {/* ── FAQ ── */}
        <section className="vrh-section vrh-section--tint" id="help">
          <div className="vrh-wrap vrh-faq">
            <div className="vrh-faq__head">
              <h2>Questions people ask</h2>
              <p>Can't find your answer? <a href="#contact">Send us a message</a>.</p>
            </div>
            <div className="vrh-faq__list">
              {FAQS.map((f, i) => {
                const open = openFaq === i;
                return (
                  <div key={f.q} className={`vrh-faq__item ${open ? "is-open" : ""}`}>
                    <h3>
                      <button
                        type="button"
                        aria-expanded={open}
                        aria-controls={`faq-${i}`}
                        id={`faq-q-${i}`}
                        onClick={() => setOpenFaq(open ? null : i)}
                      >
                        {f.q}
                        <Icon name="plus" />
                      </button>
                    </h3>
                    <div id={`faq-${i}`} role="region" aria-labelledby={`faq-q-${i}`} hidden={!open}>
                      <p>{f.a}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* ── Contact ── */}
        <section className="vrh-section" id="contact">
          <div className="vrh-wrap vrh-contact">
            <div className="vrh-contact__info">
              <h2>Talk to us</h2>
              <p className="vrh-lead">
                For new connections, plan questions, operator partnerships or a School ERP demo.
                We usually reply the same working day.
              </p>
              <ul className="vrh-contact__ways">
                <li>
                  <Icon name="phone" />
                  <div>
                    <a href={`tel:+${CONTACT.phoneE164}`}>{CONTACT.phoneDisplay}</a>
                    <span>{CONTACT.hours}</span>
                  </div>
                </li>
                <li>
                  <Icon name="mail" />
                  <div>
                    <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
                    <span>Email any time</span>
                  </div>
                </li>
                <li>
                  <Icon name="pin" />
                  <div>
                    <b>SD Technologies</b>
                    <span>{CONTACT.address}</span>
                  </div>
                </li>
              </ul>
            </div>

            <div className="vrh-form-card">
              {sent ? (
                <div className="vrh-sent" role="status">
                  <h3>Your message is ready to send</h3>
                  <p>
                    We've opened WhatsApp or your email app with your message filled in — press
                    send there to reach us. Nothing opened? Call {CONTACT.phoneDisplay}.
                  </p>
                  <button type="button" className="vrh-btn vrh-btn--outline" onClick={() => setSent(false)}>
                    Write another message
                  </button>
                </div>
              ) : (
                <form onSubmit={sendWhatsApp} noValidate>
                  <div className="vrh-field">
                    <label htmlFor="c-subject">What's it about?</label>
                    <select id="c-subject" name="subject" value={form.subject} onChange={onChange}>
                      {[
                        "General enquiry",
                        "New connection",
                        "Basic plan",
                        "Premium plan",
                        "Family plan",
                        "Operator partnership",
                        "School ERP demo",
                        "Technical support",
                        "Billing",
                      ].map((s) => <option key={s}>{s}</option>)}
                    </select>
                  </div>
                  <div className="vrh-field">
                    <label htmlFor="c-name">Your name</label>
                    <input id="c-name" name="name" value={form.name} onChange={onChange} autoComplete="name" />
                  </div>
                  <div className="vrh-field-row">
                    <div className="vrh-field">
                      <label htmlFor="c-phone">Phone</label>
                      <input id="c-phone" name="phone" type="tel" inputMode="tel" value={form.phone} onChange={onChange} autoComplete="tel" />
                    </div>
                    <div className="vrh-field">
                      <label htmlFor="c-email">Email <span>(optional)</span></label>
                      <input id="c-email" name="email" type="email" value={form.email} onChange={onChange} autoComplete="email" />
                    </div>
                  </div>
                  <div className="vrh-field">
                    <label htmlFor="c-msg">Message</label>
                    <textarea id="c-msg" name="message" rows="4" value={form.message} onChange={onChange} />
                  </div>
                  {formError && <p className="vrh-form-error" role="alert">{formError}</p>}
                  <div className="vrh-form-actions">
                    <button type="submit" className="vrh-btn vrh-btn--primary">Send on WhatsApp</button>
                    <button type="button" className="vrh-btn vrh-btn--outline" onClick={sendEmail}>Send by email</button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </section>
      </main>

      {/* ── Footer ── */}
      <footer className="vrh-footer">
        <div className="vrh-wrap vrh-footer__inner">
          <div className="vrh-footer__brand">
            <img src={`${ASSET_BASE_URL}/vrplay1.png`} alt="VRPLAY" />
            <p>Live TV and OTT streaming by SD Technologies.</p>
            <PlayStoreBadge className="vrh-store--footer" />
          </div>
          <nav className="vrh-footer__col" aria-label="VRPLAY">
            <p>VRPLAY</p>
            <a href="#watch">What you get</a>
            <a href="#plans">Plans</a>
            <a href="#operators">For operators</a>
            <Link to="/login">Log in</Link>
          </nav>
          <nav className="vrh-footer__col" aria-label="Help">
            <p>Help</p>
            <a href="#help">Questions</a>
            <a href="#contact">Contact</a>
            <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">Privacy policy</a>
            <a href={TERMS_URL} target="_blank" rel="noopener noreferrer">Terms and conditions</a>
          </nav>
          <div className="vrh-footer__col">
            <p>SD Technologies</p>
            <a href={SCHOOL_ERP_URL} target="_blank" rel="noopener noreferrer">School ERP</a>
            {SOCIAL.filter((s) => s.url).map((s) => (
              <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer">{s.name}</a>
            ))}
            <span className="vrh-footer__addr">{CONTACT.address}</span>
          </div>
        </div>
        <div className="vrh-wrap vrh-footer__legal">
          <p>© {new Date().getFullYear()} VRPLAY · SD Technologies. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
